import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import {
    type CheckAvailableInventoryStockByVariantConfiguratorSettingsQuery,
    type CheckAvailableInventoryStockByVariantConfiguratorSettingsQueryVariables,
    CheckAvailableInventoryStockByVariantConfiguratorSettingsDocument,
} from '../../../api/queries/checkAvailableInventoryStockByVariantConfiguratorSettings';

const useCheckVariantConfiguratorAvailableStock = () => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (settingId: string, configuratorId: string) =>
            apolloClient.query<
                CheckAvailableInventoryStockByVariantConfiguratorSettingsQuery,
                CheckAvailableInventoryStockByVariantConfiguratorSettingsQueryVariables
            >({
                query: CheckAvailableInventoryStockByVariantConfiguratorSettingsDocument,
                fetchPolicy: 'cache-first',
                variables: { settingId, configuratorId },
            }),
        [apolloClient]
    );
};

export default useCheckVariantConfiguratorAvailableStock;
